<template>
  <div>
    <el-row
      style="height: 55px;border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 10px 0;margin: 0 20px;text-align: right; position: relative;">
      <img class="back" src="@/assets/images/back.png" alt="返回" @touchstart="back" @click="back">
      <el-button @touchstart="addTemplate" @click="addTemplate" icon="el-icon-circle-plus-outline" type="primary" v-if="!operation">新增大屏模板
      </el-button>
      <el-button @touchstart="saveLayout" @click="saveLayout" type="primary" v-if="operation">保存</el-button>
      <el-button @touchstart="goBack()" @click="goBack()" v-if="operation"><i class="el-icon-back"></i> 返回</el-button>
    </el-row>
    <platen-template-list :code="code" :page-id="pageId" :page-list="pageList"
                          @init="init"
                          v-if="!operation"></platen-template-list>

    <!--页面编辑-->
    <div class="operation" v-if="operation">
      <el-card class="box-card">
        <div class="clearfix" slot="header">
          <span class="text-lightBlue">添加模块</span>
        </div>
        <div :key="item.component" class="text item" v-for="item in enableLayout">
          <a @touchstart="clickComponent(item.component,item.name)" @click="clickComponent(item.component,item.name)">{{ item.name }}</a>
        </div>
      </el-card>
    </div>

    <div ref="dragTemplate" style="position: relative;height: calc(100vh - 58px);width: 100%">
      <!--更换空间-->
      <el-row style="height: 40px;" v-if="showSpace">
        <img :src="spaceIcon"
             style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;">
        <div style="line-height: 40px;">
          <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
          <a @touchstart="spaceTreeDisable = !spaceTreeDisable" @click="spaceTreeDisable = !spaceTreeDisable" class="pointer text-white"
             style="margin-left: 10px;">更换空间</a>
        </div>
        <space-choose @close="spaceTreeDisable = false"
                      @spaceClick="spaceClick"
                      ref="spaceChoose" v-show="spaceTreeDisable"></space-choose>
      </el-row>

      <img src="static/background.png" style="width: 100%;height: 97vh" v-if="isDownload">

      <vue-draggable-resizable
        :debug="false"
        :h="item.position.height * (winHeight / item.position.innerHeight)"
        :isConflictCheck="false"
        :isDraggable="edit"
        :isResizable="edit"
        :key="item.componentsName"
        :parent="true"
        :snap="true"
        :snapTolerance="1"
        :w="item.position.width * (winWidth / item.position.innerWidth) "
        :x="item.position.left * (winWidth / item.position.innerWidth) "
        :y="item.position.top  * (winHeight / item.position.innerHeight)"
        @dragstop="(x,y) => {return dragStop(x,y,item)}"
        @refLineParams="getRefLineParams"
        @resizestop="(x,y,width,height) => {return resizeStop(x,y,width,height,item)}"
        v-for="item in curComponents">
        <!--全景图-->
        <div style="border:1px dashed rgba(1,239,253,.6);height: 100%" v-if="item.componentsName === 'IndoorSetting'">
          <img :ref="item.componentsName" @touchstart="deleteComponent(item.componentsName)" @click="deleteComponent(item.componentsName)"
               class="pointer" src="../../assets/images/icon/delete.png"
               style="position: absolute;right: 20px;top: 20px;z-index: 9;" v-show="edit">
          <span :ref="item.componentsName" @touchstart="displaySetting(item)" @click="displaySetting(item)"
                class="pointer" style="position: absolute;right: 50px;top: 17px;z-index: 9;color: #299ffb;
                border-bottom: 1px solid #299ffb;"
                v-show="edit">
            显示设置</span>
          <component :displaySetting="{}" :is="item.component"
                     :space-id="currentSpaceInfo.id"></component>
        </div>

        <border-corner v-else>
          <div :class="item.componentsName === 'AlarmInfo' ? 'alarmLists' : ''" slot="content"
               style="border:1px solid rgba(1,239,253,.6);height: 100%">
            <i :ref="item.componentsName" @touchstart="deleteComponent(item.componentsName)" @click="deleteComponent(item.componentsName)" class="el-icon-delete"
               style="position: absolute;right: 5px;top: 2px;z-index: 9;" v-show="edit"></i>
            <component :is="item.component"></component>
          </div>
        </border-corner>
      </vue-draggable-resizable>
      <!--辅助线-->
      <span :key="item.id"
            :style="{ left: item.position, top: item.origin, height: item.lineLength}"
            class="ref-line v-line"
            v-for="item in vLine"
            v-show="item.display"
      />
      <span :key="item.id"
            :style="{ top: item.position, left: item.origin, width: item.lineLength}"
            class="ref-line h-line"
            v-for="item in hLine"
            v-show="item.display"
      />
      <!--辅助线END-->
    </div>

    <!--    弹出窗-->
    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="settingSaveDialogVisible"
      @dialogClose="(data) => this.settingSaveDialogVisible = data"
      center
      :width="dialogWidth">
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <PlatenSettingSave :code="code" ref="platenSettingSave"
                           v-if="operate === 'platenSettingSave'"></PlatenSettingSave>
        <display-setting :dialogData="dialogData" @getDisplaySettingData="getDisplaySettingData"
                         ref="displaySetting"
                         v-if="operate === 'displaySetting'"
        ></display-setting>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 5px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.settingSaveDialogVisible = false;}" @click="() => {this.settingSaveDialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
import borderCorner from "@/components/style/BorderCorner";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import PlatenTemplateList from "@/views/platen/PlatenTemplateList";
import PlatenSettingSave from "@/views/platen/PlatenSettingSave";
import {componentList} from "@/assets/js/components/componentList";
import {getCustomListByPage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import html2canvas from 'html2canvas'
import lodash from "lodash";
import _ from "lodash";
import SpaceChoose from "@/views/overview/SpaceChoose";
import DisplaySetting from "@/views/platen/DisplaySetting";

export default {
  name: "PlatenSetting",
  components: {
    VueDraggableResizable,
    borderCorner,
    componentList,
    PlatenTemplateList,
    FunctionDialogComponent,
    PlatenSettingSave,
    SpaceChoose,
    DisplaySetting
  },
  computed: {
    showSpace() {
      return this.curComponents.filter(item => item.componentsName === 'IndoorSetting').length > 0
    }
  },
  data() {
    return {
      /** 注入给大屏子组件：布局编辑中为 true 时禁用跳转 */
      platenLayoutEditState: {
        isEditing: false
      },
      title: '',
      settingSaveDialogVisible: false,
      dialogWidth: '',
      operate: '',
      pageList: [],
      timer: null,
      pageUrl: "/platen/index",
      componentList: [], //所有组件配置
      enableLayout: [], //可用组件
      componentsList: [], //页面默认组件配置
      allComponents: [], //所有展示组件
      curComponents: [], //当前页面展示组件
      winWidth: 0,
      winHeight: 0,
      currentDragId: 0,
      editIcon: false,
      edit: false,
      operation: false,
      pageId: null,
      code: "screen_template",
      codes: ["screen_template", "capacity_system"],
      isDownload: false,
      spaceTreeDisable: false,
      currentSpaceInfo: {id: '0', title: '暂无空间'},
      displaySettingData: {}, //全景图显示配置
      dialogData: {},
      spaceIcon: require('../../assets/images/index/roomIcon.png'),
      vLine: [],
      hLine: []
    }
  },
  inject: ['reload'],
  provide() {
    return {
      platenLayoutEditState: this.platenLayoutEditState
    }
  },
  watch: {
    edit: {
      handler(val) {
        this.platenLayoutEditState.isEditing = val
      },
      immediate: true
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    // window.addEventListener('resize', () => {
    //   this.winWidth = window.innerWidth;
    //   this.winHeight = window.innerHeight;
    // })
  },
  methods: {
    // 辅助线回调事件
    getRefLineParams(params) {
      const {vLine, hLine} = params
      let id = 0
      this.vLine = vLine.map(item => {
        item['id'] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item['id'] = ++id
        return item
      })
    },
    //更换按钮
    spaceClick(data) {
      this.currentSpaceInfo = data
    },
    init() {
      this.getCustomListByPage();
      this.getSystematicByCodes()
    },
    getSystematicByCodes() {
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          this.componentList = lodash.cloneDeep(componentList).filter(item => item.component !== 'Pue')
          res.data.forEach(item => {
            switch (item.code) {
              case 'screen_template':
                this.pageId = item.val1;
                break;
              case 'capacity_system':
                if (item.val1 === 'true') {
                  this.componentList = lodash.cloneDeep(componentList)
                }
                break;
            }
          })
          this.formatAllComponents();
          this.enableLayout = this.componentList.map(item => ({...item}));
        }
      })
    },
    //格式化所有组件
    formatAllComponents() {
      this.allComponents = [];
      this.componentList.forEach(item => {
        let component = {};
        component.component = () => import('@/components/component/' + item.component + '.vue');
        component.componentsName = item.component;
        component.position = {
          width: item.size.width,
          height: item.size.height,
          top: 20,
          left: 20,
          innerWidth: this.winWidth,
          innerHeight: this.winHeight
        };
        this.allComponents.push(component)
      })
    },
    //模板列表
    getCustomListByPage() {
      getCustomListByPage(this.pageUrl).then(res => {
        if (res.code === 0) {
          this.pageList = res.data
        }
      })
    },
    //点击组件
    clickComponent(component, name) {
      //当前页面添加所选组件
      this.allComponents.forEach(item => {
        if (item.componentsName === component) {
          item.params = JSON.stringify(item.position);
          item.name = name;
          this.curComponents.push(item)
        }
      });
      //可选组件中移除组件配置
      this.enableLayout.forEach((item, index) => {
        if (item.component === component) {
          this.enableLayout.splice(index, 1)
        }
      })
    },
    //停止放大缩小
    resizeStop(x, y, width, height, row) {
      const params = JSON.parse(row.params);
      params.left = x;
      params.top = y;
      params.width = width;
      params.height = height;
      this.setParam(params, row)
    },
    //停止拖拽
    dragStop(x, y, row) {
      const params = JSON.parse(row.params);
      params.left = x;
      params.top = y;
      this.setParam(params, row)
    },
    //更新当前布局
    setParam(params, row) {
      params.innerWidth = this.winWidth;
      params.innerHeight = this.winHeight;
      const item = {};
      item.params = JSON.stringify(params);
      this.componentList.forEach(component => {
        if (component.component === row.componentsName) {
          item.name = component.name
        }
      });
      item.componentsName = row.componentsName;
      //更新当前拖拽布局的位置
      this.curComponents.map(com => {
        if (com.componentsName === row.componentsName) {
          com.params = item.params;
        }
        return com
      })
    },

    //移除组件
    deleteComponent(component) {
      //当前页面移除所选组件
      this.curComponents.forEach((item, index) => {
        if (item.componentsName === component) {
          this.curComponents.splice(index, 1)
        }
      });
      //可选组件中添加组件配置
      this.componentList.forEach(item => {
        if (item.component === component) {
          this.enableLayout.push(item);
        }
      })
    },
    //新增模板
    addTemplate() {
      this.operation = true;
      this.edit = true;
      this.editIcon = false;
    },
    //保存布局按钮
    saveLayout() {
      if (this.curComponents.length > 0) {
        const indoorSetting = this.curComponents.filter(item => item.componentsName === 'IndoorSetting')[0]
        if (indoorSetting) {
          let params = JSON.parse(indoorSetting.params)
          if (params.displaySetting === undefined) {
            this.$message.info("请先添加显示设置!")
            return false;
          }
        }
        const canvas = document.createElement('canvas');
        // 获取要生成图片的 DOM 元素
        let canvasDom = this.$refs.dragTemplate;
        // 获取指定的宽高
        const width = parseInt(window.getComputedStyle(canvasDom).width);
        const height = window.innerHeight - 55;
        // 宽高扩大 2 倍 处理图片模糊
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        const context = canvas.getContext('2d');
        context.scale(1, 1);
        const options = {
          // backgroundColor: null,
          canvas: canvas,
          useCORS: true
        };
        canvasDom.style.backgroundImage = 'url(static/background.png)';
        canvasDom.style.height = '100vh';
        html2canvas(canvasDom, options).then(canvas => {
          this.isDownload = true;
          // 生成图片地址
          this.imgUrl = canvas.toDataURL('image/png');
          this.saveFile(this.imgUrl, '背景图');
        });
        this.dialogWidth = '35vw';
        this.title = '保存大屏模板';
        this.operate = 'platenSettingSave';
        this.settingSaveDialogVisible = true;
      } else {
        this.$message.error("模板不能为空!")
      }
    },
    // 保存
    saveFile(data, filename) {
      const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      save_link.href = data;
      save_link.download = filename;

      const event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      save_link.dispatchEvent(event);
      this.isDownload = false
    },
    //返回
    goBack() {
      this.reload();
    },
    back() {
      this.$router.go(-1);
    },
    displaySetting(item) {
      this.dialogData = item;
      this.dialogWidth = '45vw';
      this.title = '显示设置';
      this.operate = 'displaySetting';
      this.settingSaveDialogVisible = true;
    },
    //获取全景图显示配置
    getDisplaySettingData(data) {
      this.displaySettingData = data
    },
    preservation() {
      //保存显示设置
      if (this.operate === 'displaySetting') {
        if (this.displaySettingData.type === '3' || this.displaySettingData.type === '4') {
          if (this.displaySettingData.checkboxList.length < 1) {
            this.$message.error("至少选择一个检测指标!")
            return
          }
        }
        this.curComponents = this.curComponents.map(item => {
          if (item.componentsName === this.dialogData.componentsName) {
            let params = JSON.parse(item.params)
            params.displaySetting = this.displaySettingData
            item.params = JSON.stringify(params)
          }
          return item;
        })
        this.settingSaveDialogVisible = false;
      } else {
        this.$refs.platenSettingSave.preservation(this.pageUrl, _.cloneDeep(this.curComponents));
      }
    },
  }
}
</script>

<style scoped>
.back {
  width: 36px;
  height: 36px;
  cursor: pointer;
  position: absolute;
  left: 0px;
}
.operation {
  width: 200px;
  margin: 20px;
  float: right;
  position: relative;
  background-color: rgba(255, 255, 255, .2);
  z-index: 10;
}

.el-card {
  border: none;
  background-color: transparent;
  color: #fff;
}

.alarmLists {
  padding: 30px 35px 30px 60px;
  height: 100%;
  overflow-y: scroll;
  text-align: right;
}

.alarmLists::-webkit-scrollbar {
  display: none
}

/*.el-button {*/
/*  color: #fff;*/
/*  font-size: 0.9rem;*/
/*  background-color: rgba(41, 155, 255, .2);*/
/*  border: none;*/
/*}*/

/*.el-button:hover {*/
/*  background-color: rgba(41, 155, 255, .4) !important;*/
/*  color: #fff;*/
/*}*/

.vdr.active:before {
  outline: none;
}

.item a:hover {
  cursor: pointer;
}
</style>
